import { api } from './authService';

function getTenantBase(): string {
  const tenantCode = localStorage.getItem('currentTenant') || 'default';
  return `/${tenantCode}/whatsappapi`;
}

export interface AgentConversationQuery {
  page?: number;
  pageSize?: number;
  channel_type?: string;
  channel_agent_id?: string;
  channel_user_id?: string;
  agent_user_id?: string;
  agent_platform_id?: string | number;
  agent_id?: string | number;
  conversation_id?: string;
  conversation_status?: string;
}

export interface AgentMessageQuery {
  page?: number;
  pageSize?: number;
  conversation_id?: string;
  direction?: 'inbound' | 'outbound';
  status?: string;
}

export interface AgentConversation {
  conversation_id: string;
  channel_type?: string;
  channel_agent_id?: string;
  channel_user_id?: string;
  agent_user_id?: string;
  agent_platform_id?: string | number;
  agent_id?: string | number;
  conversation_status?: string;
  last_message_at?: string;
  created_at?: string;
  updated_at?: string;
  [key: string]: any;
}

export interface AgentMessage {
  id?: string | number;
  message_id?: string;
  conversation_id: string;
  direction: 'inbound' | 'outbound' | string;
  status?: string;
  content?: any;
  created_at?: string;
  [key: string]: any;
}

function buildQueryString(params: Record<string, any> | undefined): string {
  if (!params) return '';
  const search = new URLSearchParams();
  Object.entries(params).forEach(([k, v]) => {
    if (v !== undefined && v !== null && v !== '') search.append(k, String(v));
  });
  const qs = search.toString();
  return qs ? `?${qs}` : '';
}

export const whatsappConnectorAgentApi = {
  async getAgentConversations(params?: AgentConversationQuery): Promise<{ data: AgentConversation[]; total?: number; page?: number; pageSize?: number }>{
    const url = `${getTenantBase()}/agent/conversations${buildQueryString(params as any)}`;
    const res = await api.get(url);
    return res.data;
  },

  async getAgentMessages(params?: AgentMessageQuery): Promise<{ data: AgentMessage[]; total?: number; page?: number; pageSize?: number }>{
    const url = `${getTenantBase()}/agent/messages${buildQueryString(params as any)}`;
    const res = await api.get(url);
    return res.data;
  },

  async getAgentConversationMessages(conversationId: string, params?: { page?: number; pageSize?: number }): Promise<{ data: AgentMessage[]; total?: number; page?: number; pageSize?: number }>{
    const url = `${getTenantBase()}/agent/conversations/${encodeURIComponent(conversationId)}/messages${buildQueryString(params as any)}`;
    const res = await api.get(url);
    return res.data;
  }
};


